const state = {
  questions: []
};

const getters = {
  questions: state => state.questions
};

const actions = {
  // Initialize the Questions State on app load
  initializeQuestions({commit}, questions) {
    return commit('INITIALIZE_QUESTIONS', questions);
  },
  setElectionsVote({commit}, vote) {
    return commit('SET_CANDIDATEVOTE', {...vote});
  },
  updateVote({commit}, {questionId, vote}) {
    return commit('UPDATE_VOTE', {questionId, vote});
  },
  updateAbstainOption({commit}, {questionId, option}) {
    return commit('UPDATE_ABSTAIN_OPTION', {questionId, option});
  },
  updateVoteResident({commit}, questionId, isResident) {
    if (isResident !== 'yes') {
      // This is a state change, so reset the vote answer.
      commit('UPDATE_VOTE', questionId, {selection: []});
    }
    return commit('UPDATE_VOTE_RESIDENT', questionId, isResident);
  },
  updateNominees({commit}, {questionId, nominees}) {
    return commit('UPDATE_NOMINEES', {questionId, nominees});
  },
  clearQuestions({commit}) {
    return commit('RESET_QUESTIONS');
  }
};

const mutations = {
  // Initialize the Questions State on app load
  INITIALIZE_QUESTIONS(state, questions) {
    if (!questions) {
      return (state.questions = []);
    }

    const initialQuestions = questions.map(question => {
      // Check if there are any nominees defined
      const initialNominees = question.options ? [...question.options] : [];

      return {
        ...question,
        vote: {
          selection: [''],
          option: ['']
        },
        // Store the initial nominees for no-candidate checks
        initialOptions: initialNominees
      };
    });
    state.questions = initialQuestions;
  },

  // Update the Vote
  UPDATE_VOTE(state, {questionId, vote}) {
    state.questions[questionId].vote.selection = vote;
  },

  // Update the Abstain Option
  UPDATE_ABSTAIN_OPTION(state, {questionId, option}) {
    state.questions[questionId].vote.option = option;
  },

  // Update for nominee list
  UPDATE_NOMINEES(state, {questionId, nominees}) {
    state.questions[questionId].nominees = nominees;
  },

  // Update resident status for elections with owner occupied position
  UPDATE_VOTE_RESIDENT(state, {questionId, isResident}) {
    state.questions[questionId].isResident = isResident;
  },

  RESET_QUESTIONS(state) {
    state.questions = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
